import { render, staticRenderFns } from "./debtor.vue?vue&type=template&id=67977db4&"
import script from "./debtor.vue?vue&type=script&lang=js&"
export * from "./debtor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports